import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _Set from "@babel/runtime-corejs3/core-js/set";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _findIndexInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find-index";
import moment from "moment";
import { ADD_SUBMISSION_AGENT, ADD_SUBMISSION_RECORD, EDIT_DOCUMENT_FORM, EDIT_SUBMISSION_AGENT, SET_APPLICATION_FEES, SET_APPLICATION_FEES_SAVING_STATUS, SET_APPLICATION_FEES_UPDATED_AT, SET_CREDIT_REPORTS, SET_ADDITIONAL_REPORTS, SET_CREDIT_SUBJECTS, SET_DOCUMENT_FORMS, SET_DOCUMENT_FORM_SELECTION, SET_EDITING_DOCUMENT_FORM, SET_LENDERS, SET_PARTICIPANTS, SET_REQUESTING_BUREAU_STATUS, SET_SUBMISSION_HISTORY, SET_SUBMIT_TO_LENDER_FLAG, SET_VALIDATION_RULES_RESULT, UPDATE_SUBMISSION_RECORD, SET_LENDER_NOTE, SET_SUBMISSION_HISTORY_STATUS, SET_MPP_DATA, SET_MANUAL_RESPONSE, ADD_MPP, SET_COMMISSIONS_FEES, UPDATE_COMMISSION_DEDUCTION, SET_COMMISSION_DEDUCTION, SET_COMMISSION_CALCULATED_DETAILS, ADD_COMMISSION_DEDUCTION, DELETE_COMMISSION_DEDUCTION, SET_COMMISSIONS_DETAILS, SET_COMMISSIONS_DETAILS_PARTICIPANT, ADD_COMMISSION_FEE, REMOVE_COMMISSION_FEE, SET_COMMISSION_FEE, SET_COMMISSIONS_DETAILS_PRIMARY_CONTACT, DELETE_COMMISSIONS_DETAILS_PARTICIPANT, SET_TOTAL_COMMISSIONS_FEES, SET_LOADING_TOTAL_COMMISSIONS_FEES, SET_CO_BROKERING_HISTORY, SET_CO_BROKER_BROKERAGES, SET_CO_BROKER_BROKERAGES_COUNT, SET_LOADING_CO_BROKER_AGENTS, SET_CO_BROKER_AGENTS_COUNT } from "./lender-submit-mutations";
import { assignSubmissionAgent, changeReportSubmitToLender, copyLiabilities, createSubmissionAgent, getApplicationFees, getCreditReports, getCreditSubjects, getDocumentFormData, getDocumentForms, getMppData, getLenders, getSubmissionAgents, getSubmissionHistory, getValidationRulesResult, printDocumentForms, requestCreditBureau, saveDocumentFormData, saveFees, submitApplicationToLender, toggleDealStatus, updateSubmissionAgent, createManualResponse, generateMpp, getSubmissionNote, updateSubmissionNote, assignReferralSource, getCommissionsFees, printCommissions, updateCommissionDeduction, getCommissionDeduction, createCommissionDeduction, deleteCommissionDeduction, getCommissionsDetails, getCommissionsDetailsParticipants, addCommissionsDetailsParticipant, updateCommissionsDetails, updateParticipantsSplits, updatePrimaryContact, addCommissionFee, deleteCommissionFee, changeCommissionFee, deleteCommissionsDetailsParticipant, changeDefaultCommissionFee, getCoBrokeringHistory, getCoBrokerBrokerages, getCoBrokerAgents, getCoBrokerFavorites, coBrokerApplication, addCoBrokerToFavoritesList, removeCoBrokerFromFavoritesList, getAdditionalReports, requestAmlService } from "./../api/lender-submit-api";
import { creditReportsSchema, submissionAgentsSchema, submissionHistorySchema, mppSchema, commissionDeductionsSchema, commissionParticipantsSchema, commissionsFeesSchema } from "./lender-submit-schema";
import Err from "../../../../../routes/error";
import { ADD_APPLICATION_GROUP, LOAD_APPLICATION_DATA, LOAD_CALCULATIONS_DATA, REMOVE_APPLICATION_GROUP } from "./application-actions";
import { SET_APPLICATION_REFERRAL_SOURCE, SET_APPLICATION_SUBMISSION_AGENT, UPDATE_APPLICATION_DETAILS } from "./application-mutations";
import { normalize } from "normalizr";
import { openFileDialog } from "@Shared/utils/utils";
import { ERROR_HEADER, TOASTR_ERROR_OPTIONS, showToast } from "@Shared/utils/constants";
import Amplitude from "@Shared/utils/amplitude";
import { getDocumentsApi } from "@Shared/utils/ajax";
import WindowDownloaderTemplate from "@Shared/@HandlebarsTemplates/general/_window-downloader.hbs";
import { AGENT_IS_OWNER, CURRENT_APPLICATION, CURRENT_APPLICATION_ID } from "./application-getters";
import { CO_BROKERING_HISTORY, GET_COMMISSION_DETAILS_PARTICIPANTS, GET_COMMISSION_DETAILS_PRIMARY_CONTACT, IS_AGENTS_SPLIT_SUMMARY_COMPLETED } from "./lender-submit-getters";
import { DealTypeE, DealPurposeE, MortgageTypeE } from "@Broker/@Utils/enum";
import { assign, cloneDeep, isEmpty, omit } from "lodash";
import { getNewStatusAfterSubmission } from "@Broker/js/custom/utils";
import { ENUM_FILOGIX_STATUS } from "@Shared/js/enum";
import i18n from "@Shared/@i18n/";
import ApplicationGenerator from "@Shared/@Utils/application-generator";
export const LOAD_SUBMISSION_HISTORY = "LOAD_SUBMISSION_HISTORY";
export const LOAD_MPP_DATA = "LOAD_MPP_DATA";
export const SUBMIT_TO_LENDER = "SUBMIT_TO_LENDER";
export const TOGGLE_DEAL_ACCEPTED_STATUS = "TOGGLE_DEAL_ACCEPTED_STATUS";
export const UN_ACCEPT_DEAL = "UN_ACCEPT_DEAL";
export const LOAD_VALIDATION_RULES_RESULT = "LOAD_VALIDATION_RULES_RESULT";
export const LOAD_LENDERS = "LOAD_LENDERS";
export const LOAD_PARTICIPANTS = "LOAD_PARTICIPANTS";
export const LOAD_CREDIT_SUBJECTS = "LOAD_CREDIT_SUBJECTS";
export const LOAD_CREDIT_REPORTS = "LOAD_CREDIT_REPORTS";
export const LOAD_ADDITIONAL_REPORTS = "LOAD_ADDITIONAL_REPORTS";
export const LOAD_APPLICATION_FEES = "LOAD_APPLICATION_FEES";
export const REQUEST_CREDIT_BUREAU = "REQUEST_CREDIT_BUREAU";
export const REQUEST_AML_SERVICE = "REQUEST_AML_SERVICE";
export const LOAD_DOCUMENT_FORMS = "LOAD_DOCUMENT_FORMS";
export const LOAD_EDITING_DOCUMENT_FORM = "LOAD_EDITING_DOCUMENT_FORM";
export const TOGGLE_FORM_SELECTED = "TOGGLE_FORM_SELECTED";
export const PRINT_SELECTED_FORMS = "PRINT_SELECTED_FORMS";
export const PRINT_DOCUMENT_FORM = "PRINT_DOCUMENT_FORM";
export const SAVE_FORM_DATA = "SAVE_FORM_DATA";
export const COPY_LIABILITIES_FROM_CB = "COPY_LIABILITIES_FROM_CB";
export const SAVE_SUBMISSION_AGENT = "SAVE_SUBMISSION_AGENT";
export const UPDATE_SUBMISSION_AGENT = "UPDATE_SUBMISSION_AGENT";
export const ASSIGN_SUBMISSION_AGENT = "ASSIGN_SUBMISSION_AGENT";
export const CHANGE_REPORT_SUBMIT_TO_LENDER = "CHANGE_REPORT_SUBMIT_TO_LENDER";
export const SAVE_APPLICATION_FEES = "SAVE_APPLICATION_FEES";
export const UPDATE_LENDER_SUBMISSION_DATA = "UPDATE_LENDER_SUBMISSION_DATA";
export const PREVIEW_LENDER_RESPONSE = "PREVIEW_LENDER_RESPONSE";
export const UPDATE_LENDER_NOTE = "UPDATE_LENDER_NOTE";
export const SUBMIT_MANUAL_RESPONSE = "SUBMIT_MANUAL_RESPONSE";
export const DOWNLOAD_MPP_DOCUMENT = "DOWNLOAD_MPP_DOCUMENT";
export const LOAD_MANUAL_RESPONSE = "LOAD_MANUAL_RESPONSE";
export const PREVIEW_MPP_DOCUMENT = "PREVIEW_MPP_DOCUMENT";
export const GENERATE_MPP = "GENERATE_MPP";
export const LOAD_LENDER_SUBMISSION_NOTE = "LOAD_LENDER_SUBMISSION_NOTE";
export const PRINT_COMMISSIONS = "PRINT_COMMISSIONS";
export const UPDATE_SUBMISSIONS_HISTORY_AFTER_APPLICATION_COMPLETE = "UPDATE_SUBMISSIONS_HISTORY_AFTER_APPLICATION_COMPLETE";
export const ASSIGN_APPLICATION_REFERRAL_SOURCE = "ASSIGN_APPLICATION_REFERRAL_SOURCE";
export const LOAD_COMMISSIONS_FEES = "LOAD_COMMISSIONS_FEES";
export const ADD_NEW_COMMISSION_FEE = "ADD_NEW_COMMISSION_FEE";
export const DELETE_COMMISSION_FEE = "DELETE_COMMISSION_FEE";
export const CHANGE_COMMISSION_FEE = "CHANGE_COMMISSION_FEE";
export const SAVE_COMMISSION_DEDUCTION = "SAVE_COMMISSION_DEDUCTION";
export const GET_COMMISSION_DEDUCTION = "GET_COMMISSION_DEDUCTION";
export const CREATE_COMMISSION_DEDUCTION = "CREATE_COMMISSION_DEDUCTION";
export const REMOVE_COMMISSION_DEDUCTION = "REMOVE_COMMISSION_DEDUCTION";
export const LOAD_COMMISSIONS_DETAILS = "LOAD_COMMISSIONS_DETAILS";
export const ADD_COMMISSIONS_DETAILS_PARTICIPANT = "ADD_COMMISSIONS_DETAILS_PARTICIPANT";
export const UPDATE_COMMISSIONS_DETAILS_PARTICIPANT = "UPDATE_COMMISSIONS_DETAILS_PARTICIPANT";
export const UPDATE_COMMISSIONS_DETAILS = "UPDATE_COMMISSIONS_DETAILS";
export const UPDATE_COMMISSIONS_DETAILS_PRIMARY_CONTACT = "UPDATE_COMMISSIONS_DETAILS_PRIMARY_CONTACT";
export const REMOVE_COMMISSIONS_DETAILS_PARTICIPANT = "REMOVE_COMMISSIONS_DETAILS_PARTICIPANT";
export const LOAD_CO_BROKERING_HISTORY = "LOAD_CO_BROKERING_HISTORY";
export const LOAD_CO_BROKER_BROKERAGES = "LOAD_CO_BROKER_BROKERAGES";
export const LOAD_CO_BROKER_AGENTS = "LOAD_CO_BROKER_AGENTS";
export const LOAD_CO_BROKER_FAVORITES = "LOAD_CO_BROKER_FAVORITES";
export const CO_BROKER_APPLICATION = "CO_BROKER_APPLICATION";
export const UPDATE_CO_BROKERED_MORTGAGE = "UPDATE_CO_BROKERED_MORTGAGE";
export const ADD_CO_BROKER_TO_FAVORITES_LIST = "ADD_CO_BROKER_TO_FAVORITES_LIST";
export const REMOVE_CO_BROKER_FROM_FAVORITES_LIST = "REMOVE_CO_BROKER_FROM_FAVORITES_LIST";
export default {
  [LOAD_SUBMISSION_HISTORY]: async (context, {
    clientUsername,
    applicationId
  }) => {
    const {
      submissionHistory
    } = await getSubmissionHistory(clientUsername, applicationId);
    const {
      entities,
      result
    } = normalize(submissionHistory, [submissionHistorySchema]);
    context.commit(SET_SUBMISSION_HISTORY, {
      submissionHistory: {
        byId: entities.submissionHistory || {},
        allIds: result
      }
    });
  },
  [CO_BROKER_APPLICATION]: async (context, {
    cobrokerUsername,
    mortgages,
    brokerName,
    brokerageName,
    clientUsername,
    applicationId
  }) => {
    try {
      const coBrokeringHistory = await coBrokerApplication(cobrokerUsername, mortgages, brokerName, brokerageName, clientUsername, applicationId);
      context.commit(SET_CO_BROKERING_HISTORY, {
        coBrokeringHistory
      });
      showToast("success", "coBrokeringSuccess");
      return {
        succeeded: true
      };
    } catch (e) {
      Err.handle(e);
      return {
        succeeded: false
      };
    }
  },
  [LOAD_MPP_DATA]: async (context, {
    clientUsername,
    applicationId,
    submissionId
  }) => {
    try {
      const mppData = await getMppData(clientUsername, applicationId, submissionId);
      const {
        entities,
        result
      } = normalize(mppData, [mppSchema]);
      context.commit(SET_MPP_DATA, {
        mpp: {
          byId: entities.mpp || {},
          allIds: [...new _Set(result)]
        }
      });
    } catch (e) {
      Err.handle(e);
      throw e;
    }
  },
  [TOGGLE_DEAL_ACCEPTED_STATUS]: async (context, {
    agentUsername,
    clientUsername,
    applicationId,
    submissionId
  }) => {
    try {
      const {
        status
      } = await toggleDealStatus(clientUsername, applicationId, submissionId);
      context.commit(UPDATE_SUBMISSION_RECORD, {
        submissionId,
        details: {
          status
        }
      });
      if (status === ENUM_FILOGIX_STATUS.accepted) {
        //reload application data to update current application stored
        await context.dispatch(LOAD_APPLICATION_DATA, {
          clientUsername,
          agentUsername,
          applicationId
        });
        await context.dispatch(LOAD_CALCULATIONS_DATA, {
          clientUsername,
          applicationId
        });
      }
      showToast("success", "lenderResponseUpdated");
    } catch (error) {
      Err.handle(error, {
        clientUsername,
        applicationId,
        submissionId
      });
      throw error;
    }
  },
  [LOAD_VALIDATION_RULES_RESULT]: async (context, {
    clientUsername,
    applicationId,
    submissionData
  }) => {
    try {
      const {
        valid = false,
        businessErrors = []
      } = await getValidationRulesResult(clientUsername, applicationId, submissionData);
      context.commit(SET_VALIDATION_RULES_RESULT, {
        applicationId,
        validationRulesResult: {
          valid,
          businessErrors
        }
      });
    } catch (e) {
      context.commit(SET_VALIDATION_RULES_RESULT, {
        applicationId,
        validationRulesResult: {
          valid: false,
          businessErrors: [{
            softStop: false
          }]
        }
      });
      Err.handle(e);
      throw e;
    }
  },
  [LOAD_LENDERS]: async (context, fetchLenders = {}) => {
    // There's the possibility that during loading with the all = true flag and moving to a page with all = false
    // you can see and use the old lender list for a moment, the intent here is to clear the lender list first
    // before trying to load the new one
    context.commit(SET_LENDERS, {
      lenders: []
    });
    const {
      lendersFull
    } = await getLenders({
      all: fetchLenders.all,
      applicationId: fetchLenders.applicationId
    });
    context.commit(SET_LENDERS, {
      lenders: lendersFull
    });
  },
  [LOAD_PARTICIPANTS]: async (context, {
    agentUsername
  }) => {
    const currentApplication = context.getters["CURRENT_APPLICATION"];
    const appOwner = currentApplication.appOwnerDetails || {};
    const currentUserAddress = context.rootState.AccountStore.userDetails.address;
    const agentIsOwner = context.getters[AGENT_IS_OWNER](agentUsername);
    const agentAddress = agentIsOwner ? currentUserAddress : appOwner.address;
    const agent = _objectSpread(_objectSpread({}, appOwner), {}, {
      address: agentAddress
    });
    const {
      submissionAgents = []
    } = await getSubmissionAgents();
    const {
      entities,
      result
    } = normalize(submissionAgents, [submissionAgentsSchema]);
    context.commit(SET_PARTICIPANTS, {
      agent,
      submissionAgents: {
        byId: entities.submissionAgents || {},
        allIds: result
      }
    });
  },
  [SAVE_SUBMISSION_AGENT]: async (context, {
    submissionAgent
  }) => {
    const {
      submissionAgentId
    } = await createSubmissionAgent(submissionAgent);
    context.commit(ADD_SUBMISSION_AGENT, _objectSpread(_objectSpread({}, submissionAgent), {}, {
      submissionAgentId
    }));
    return submissionAgentId;
  },
  [UPDATE_SUBMISSION_AGENT]: async (context, {
    submissionAgent
  }) => {
    const {
      submissionAgentId
    } = submissionAgent;
    const oldSubmissionAgent = context.state.participants.submissionAgents.byId[submissionAgentId];
    context.commit(EDIT_SUBMISSION_AGENT, {
      submissionAgent
    });
    try {
      await updateSubmissionAgent(submissionAgentId, submissionAgent);
    } catch (e) {
      context.commit(EDIT_SUBMISSION_AGENT, {
        submissionAgents: oldSubmissionAgent
      });
      throw e;
    }
  },
  [ASSIGN_SUBMISSION_AGENT]: async (context, {
    submissionAgentId,
    applicationId,
    clientUsername
  }) => {
    const currentApplication = context.getters["CURRENT_APPLICATION"];
    const oldSubmissionAgentId = currentApplication.submissionAgentId;
    context.commit(SET_APPLICATION_SUBMISSION_AGENT, {
      submissionAgentId
    });
    try {
      await assignSubmissionAgent(clientUsername, applicationId, submissionAgentId);
    } catch (e) {
      Err.handle(e);
      context.commit(SET_APPLICATION_SUBMISSION_AGENT, {
        submissionAgentId: oldSubmissionAgentId
      });
      throw e;
    }
  },
  [LOAD_CREDIT_SUBJECTS]: async (context, {
    clientUsername,
    applicationId
  }) => {
    const creditSubjects = await getCreditSubjects(clientUsername, applicationId);
    context.commit(SET_CREDIT_SUBJECTS, {
      creditSubjects
    });
  },
  [LOAD_CREDIT_REPORTS]: async (context, {
    clientUsername,
    applicationId
  }) => {
    const creditReports = await getCreditReports(clientUsername, applicationId);
    const {
      result,
      entities
    } = normalize(creditReports, [creditReportsSchema]);
    context.commit(SET_CREDIT_REPORTS, {
      creditReports: {
        allIds: result,
        byId: entities.creditReports
      }
    });
  },
  [LOAD_ADDITIONAL_REPORTS]: async (context, {
    clientUsername,
    applicationId
  }) => {
    const additionalReports = await getAdditionalReports(clientUsername, applicationId);
    context.commit(SET_ADDITIONAL_REPORTS, {
      additionalReports
    });
  },
  [LOAD_APPLICATION_FEES]: async (context, {
    clientUsername,
    applicationId
  }) => {
    try {
      const feesData = await getApplicationFees(clientUsername, applicationId);
      context.commit(SET_APPLICATION_FEES, feesData);
    } catch (e) {
      Err.handle(e);
    }
  },
  [REQUEST_CREDIT_BUREAU]: async (context, {
    clientUsername,
    applicationId
  }) => {
    const requestSubjects = context.getters.selectedBureauCreditSubjects;
    context.commit(SET_REQUESTING_BUREAU_STATUS, true);
    try {
      const creditPulls = _mapInstanceProperty(requestSubjects).call(requestSubjects, subject => ({
        requestSubjects: [subject]
      }));
      const res = await requestCreditBureau({
        clientUsername,
        applicationId
      }, {
        creditPulls
      });
      return res;
    } catch (e) {
      Err.handle(e);
    } finally {
      context.commit(SET_REQUESTING_BUREAU_STATUS, false);
    }
  },
  [REQUEST_AML_SERVICE]: async (context, {
    clientUsername,
    applicationId,
    pepRequest = false
  }) => {
    const requestSubjects = pepRequest ? context.getters.selectedPEPCreditSubjects : context.getters.selectedAMLCreditSubjects;
    context.commit(SET_REQUESTING_BUREAU_STATUS, true);
    try {
      const creditPulls = _mapInstanceProperty(requestSubjects).call(requestSubjects, subject => ({
        requestSubjects: [subject]
      }));
      const res = await requestAmlService({
        clientUsername,
        applicationId
      }, {
        creditPulls
      });
      return res;
    } catch (e) {
      Err.handle(e);
    } finally {
      context.commit(SET_REQUESTING_BUREAU_STATUS, false);
    }
  },
  [LOAD_DOCUMENT_FORMS]: async (context, {
    clientUsername,
    applicationId
  }) => {
    const {
      forms: documentForms
    } = await getDocumentForms(clientUsername, applicationId);
    context.commit(SET_DOCUMENT_FORMS, {
      applicationId,
      documentForms
    });
  },
  [LOAD_EDITING_DOCUMENT_FORM]: async (context, {
    formKey,
    clientUsername,
    applicationId,
    federal,
    mortgageType
  }) => {
    const form = await getDocumentFormData(clientUsername, applicationId, formKey, mortgageType, federal);
    context.commit(SET_EDITING_DOCUMENT_FORM, form);
    return form.formData;
  },
  [TOGGLE_FORM_SELECTED]: (context, {
    formKey,
    mortgageType,
    applicationId
  }) => {
    context.commit(EDIT_DOCUMENT_FORM, {
      formKey,
      mortgageType,
      applicationId
    });
  },
  [PRINT_SELECTED_FORMS]: async (context, {
    clientUsername,
    applicationId
  }) => {
    var _context;
    const documentForms = context.state.documentForms.byId[applicationId];
    const mortgagesSelected = _mapInstanceProperty(_context = _filterInstanceProperty(documentForms).call(documentForms, ({
      mortgagesSelected
    }) => mortgagesSelected)).call(_context, ({
      fullName
    }) => fullName);
    const printResponse = await printDocumentForms(clientUsername, applicationId, mortgagesSelected);
    window.open(printResponse.s3PresignedUrl, "_blank");
    context.commit(SET_DOCUMENT_FORM_SELECTION, {
      applicationId,
      mortgagesSelected: []
    });
  },
  [PRINT_DOCUMENT_FORM]: async (context, {
    clientUsername,
    applicationId,
    forms,
    submissionId
  }) => {
    const printResponse = await printDocumentForms(clientUsername, applicationId, forms, submissionId);
    openFileDialog(printResponse == null ? void 0 : printResponse.s3PresignedUrl, "", {
      newWindow: true
    });
    context.commit(SET_DOCUMENT_FORM_SELECTION, {
      applicationId,
      mortgagesSelected: []
    });
  },
  [SAVE_FORM_DATA]: async (context, {
    formKey,
    mortgageType,
    province,
    clientUsername,
    applicationId,
    formData
  }) => {
    await saveDocumentFormData(clientUsername, applicationId, formKey, mortgageType, province === "FEDERAL", formData);
  },
  [COPY_LIABILITIES_FROM_CB]: async (context, {
    applicationId,
    clientUsername,
    agentUsername,
    reportId,
    payload
  }) => {
    try {
      await copyLiabilities({
        applicationId,
        clientUsername,
        reportId
      }, payload);
      showToast("success", "liabilitiesCopied");
      context.dispatch(LOAD_APPLICATION_DATA, {
        clientUsername,
        applicationId,
        agentUsername
      });
    } catch (e) {
      showToast("error", "liabilitiesNotCopied", ERROR_HEADER, TOASTR_ERROR_OPTIONS);
      Err.handle(e);
      throw e;
    }
  },
  [CHANGE_REPORT_SUBMIT_TO_LENDER]: async (context, {
    applicationId,
    clientUsername,
    reportId,
    value
  }) => {
    try {
      context.commit(SET_SUBMIT_TO_LENDER_FLAG, {
        reportId,
        value
      });
      await changeReportSubmitToLender({
        applicationId,
        clientUsername,
        reportId,
        value
      });
    } catch (e) {
      context.commit(SET_SUBMIT_TO_LENDER_FLAG, {
        reportId,
        value: !value
      });
      Err.handle(e);
    }
  },
  [SAVE_APPLICATION_FEES]: async (context, {
    applicationId,
    clientUsername,
    changeApr
  }) => {
    try {
      context.commit(SET_APPLICATION_FEES_SAVING_STATUS, true);
      const applicationFees = context.state.feesCosts;
      const newFeeData = await saveFees(clientUsername, applicationId, {
        applicationFees,
        changeApr
      });
      const localLastSaved = moment().toISOString();
      context.commit(SET_APPLICATION_FEES_UPDATED_AT, localLastSaved);
      context.commit(SET_APPLICATION_FEES, newFeeData);
      Amplitude.logEvent("Direct to Lender - Fees", {
        page: "fees",
        applicationId,
        clientUsername
      });
    } catch (e) {
      Err.handle(e, {
        clientUsername,
        applicationId
      });
    } finally {
      context.commit(SET_APPLICATION_FEES_SAVING_STATUS, false);
    }
  },
  [PREVIEW_LENDER_RESPONSE]: async (context, {
    applicationId,
    lenderCommitmentDocumentS3Key,
    clientUsername
  }) => {
    const fileName = "Lender Commitment Document.pdf";
    try {
      const {
        url
      } = await getDocumentsApi({
        client: clientUsername,
        applicationId,
        fileName,
        download: false
      }, `/${lenderCommitmentDocumentS3Key}`);
      openFileDialog(url, fileName, {
        newWindow: true
      });
    } catch (e) {
      Err.handle(e);
    }
  },
  [UPDATE_LENDER_NOTE]: async (context, {
    clientUsername,
    applicationId,
    lenderNote
  }) => {
    try {
      context.commit(SET_LENDER_NOTE, {
        applicationId,
        lenderNote
      });
      await updateSubmissionNote(clientUsername, applicationId, lenderNote);
      Amplitude.logEvent("Direct to Lender - Lender Notes", {
        page: "lender notes",
        applicationId,
        clientUsername,
        lenderNote
      });
    } catch (e) {
      Err.handle(e);
    }
  },
  [DOWNLOAD_MPP_DOCUMENT]: async (context, {
    applicationId,
    s3Key,
    fileName,
    clientUsername
  }) => {
    try {
      const {
        url
      } = await getDocumentsApi({
        client: clientUsername,
        applicationId,
        fileName
      }, `/${s3Key}`);
      openFileDialog(url, fileName);
    } catch (e) {
      Err.handle(e);
    }
  },
  [SUBMIT_TO_LENDER]: async (context, {
    lenderSubmitData,
    applicationId,
    agentUsername,
    clientUsername
  }) => {
    try {
      const nowDate = moment().toISOString();
      const submissionDataDefault = {
        lenderName: "",
        dealType: "",
        lenderType: "",
        submissionMethod: "",
        lenderNote: null,
        mortgageType: "",
        ignoreSoftError: false
      };
      const submissionData = _objectSpread(_objectSpread({}, submissionDataDefault), lenderSubmitData);
      const lenderSubmitExtraData = {
        createdAt: nowDate,
        updatedAt: nowDate,
        responseAt: null,
        agentUsername,
        lenderResponse: null,
        progress: "",
        //TODO: backend needs to return this
        submittedApplicationId: applicationId
      };
      const newSubmission = await submitApplicationToLender(clientUsername, applicationId, submissionData);
      context.commit(ADD_SUBMISSION_RECORD, {
        submissionRecord: _objectSpread(_objectSpread(_objectSpread({}, submissionData), lenderSubmitExtraData), newSubmission)
      });
      return newSubmission;
    } catch (e) {
      var _e$responseJSON$messa, _e$responseJSON;
      let message = (_e$responseJSON$messa = (_e$responseJSON = e.responseJSON) == null ? void 0 : _e$responseJSON.message) != null ? _e$responseJSON$messa : "There was an error in lender submission, try again.";
      Err.handle(e, {}, message);
      throw e;
    }
  },
  [SUBMIT_MANUAL_RESPONSE]: async (context, {
    clientUsername,
    applicationId,
    submissionId,
    submittedApplicationId
  }) => {
    try {
      const loanDecision = cloneDeep(context.state.submissionManualResponse.byId[submittedApplicationId]);
      const {
        status
      } = await createManualResponse(clientUsername, applicationId, submissionId, loanDecision);
      context.commit(SET_SUBMISSION_HISTORY_STATUS, {
        submissionId,
        status
      });
      await context.dispatch(LOAD_SUBMISSION_HISTORY, {
        clientUsername,
        applicationId
      });
      showToast("success", "manualResponseSubmitted");
    } catch (e) {
      Err.handle(e);
    }
  },
  [LOAD_MANUAL_RESPONSE]: (context, {
    applicationData,
    isDecisionAccepted
  }) => {
    var _applicationData$netL, _applicationData$miPr, _applicationData$tota, _applicationData$netR, _applicationData$miPr2, _applicationData$term, _applicationData$amor, _applicationData$mort, _applicationData$rate, _applicationData$term2, _applicationData$paym, _applicationData$mort2, _applicationData$prop;
    const loanDecision = {
      response: {
        commitmentIssueDate: null,
        lenderReferenceNumber: null,
        lenderProfile: {
          lenderName: applicationData.lenderName,
          branchProfile: null
        },
        underwriter: {
          contactName: {
            contactFirstName: "",
            contactMiddleInitial: null,
            contactLastName: ""
          },
          contactPhone: {
            phoneTypeDd: 3,
            phoneNumber: ""
          },
          address: {
            address2Type: null
          },
          contactEmailAddress: null
        }
      },
      mortgage: {
        netLoanAmount: (_applicationData$netL = applicationData.netLoanAmount) != null ? _applicationData$netL : 0,
        miPremiumAmount: (_applicationData$miPr = applicationData.miPremiumAmount) != null ? _applicationData$miPr : 0,
        PAndIPaymentAmount: applicationData.pAndIPaymentAmount,
        totalLoanAmount: (_applicationData$tota = applicationData.totalLoanAmount) != null ? _applicationData$tota : 0,
        rate: {
          netRate: (_applicationData$netR = applicationData == null ? void 0 : applicationData.netRate) != null ? _applicationData$netR : 0,
          premium: (_applicationData$miPr2 = applicationData == null ? void 0 : applicationData.miPremiumRate) != null ? _applicationData$miPr2 : 0,
          buyDownRate: null,
          discount: null
        },
        rateGuaranteeLength: null,
        actualPaymentTerm: (_applicationData$term = applicationData.term) != null ? _applicationData$term : 0,
        amortizationTerm: (_applicationData$amor = applicationData.amortization) != null ? _applicationData$amor : 0,
        mortgageInsurerId: (_applicationData$mort = applicationData.mortgageInsurer) != null ? _applicationData$mort : null,
        miReferenceNumber: null,
        interestAdjustmentDate: applicationData.interestAdjustmentDate,
        interestTypeDd: (_applicationData$rate = applicationData.rateType) != null ? _applicationData$rate : null,
        paymentTermDd: (_applicationData$term2 = applicationData.termType) != null ? _applicationData$term2 : null,
        paymentFrequencyDd: (_applicationData$paym = applicationData.paymentFrequency) != null ? _applicationData$paym : null,
        cashBackAmt: null,
        cashBackOverride: null,
        cashBackPercentage: null,
        dealId: applicationData.submittedDealId,
        interestCompoundDd: applicationData.compoundedPeriod,
        loanTypeDd: applicationData.loanType || 0,
        miFeeAmount: null,
        repaymentTypeDd: applicationData.locRepaymentType || 0,
        singleProgressiveTypeDd: applicationData["progress-advance"] || 0,
        pricingRateInventory: null,
        lenderSubmission: null,
        miPremiumPst: applicationData.miPremiumPst || 0,
        mortgageTypeDd: MortgageTypeE[applicationData.mortgageType],
        mtgProviderId: (_applicationData$mort2 = applicationData.mortgageInsurer) != null ? _applicationData$mort2 : null,
        mtgProd: {
          mpBusinessId: null
        }
      },
      deal: {
        estimatedClosingDate: applicationData.closingDate,
        applicationId: applicationData.submittedApplicationId,
        dealPurposeDd: applicationData.dealPurpose || DealPurposeE[context.getters.CURRENT_APPLICATION.flow],
        dealTypeDd: DealTypeE[applicationData.dealType],
        downPaymentSource: applicationData.downPayments || [],
        taxPayorDd: ((_applicationData$prop = applicationData.propertyCost) == null ? void 0 : _applicationData$prop.taxResponsible) || 0
      }
    };
    if (isDecisionAccepted) {
      const commitment = {
        commitment: {
          commitmentExpirationDate: null,
          returnDate: null,
          DealFee: [],
          documentPDF: {},
          DocumentTracking: []
        }
      };
      loanDecision.response = assign(commitment, loanDecision.response);
    } else {
      const decline = {
        decline: {
          denialReasonDd: 0,
          denialReasons: {
            entryDate: moment().format(),
            text: ""
          }
        }
      };
      loanDecision.response = assign(decline, loanDecision.response);
    }
    context.commit(SET_MANUAL_RESPONSE, {
      loanDecision
    });
  },
  [PREVIEW_MPP_DOCUMENT]: async (context, url) => {
    const newWindow = window.open();
    newWindow.document.body.insertAdjacentHTML("beforeend", WindowDownloaderTemplate());
    if (url) {
      newWindow.location = url;
    } else {
      newWindow.close();
    }
  },
  [GENERATE_MPP]: async (context, {
    clientUsername,
    applicationId,
    submissionId,
    quote,
    mortgageType
  }) => {
    try {
      var _mppApplications$0$mp;
      const {
        mppApplications
      } = await generateMpp(clientUsername, applicationId, submissionId, mortgageType, quote);
      context.commit(ADD_MPP, mppApplications[0]);
      if (!((_mppApplications$0$mp = mppApplications[0].mppFailMessages) != null && _mppApplications$0$mp.length)) showToast("success", "mppGenerated");
    } catch (e) {
      Err.handle(e);
    }
  },
  [LOAD_LENDER_SUBMISSION_NOTE]: async (context, {
    clientUsername,
    applicationId
  }) => {
    try {
      const {
        lenderNote
      } = await getSubmissionNote(clientUsername, applicationId);
      context.commit(SET_LENDER_NOTE, {
        applicationId,
        lenderNote
      });
    } catch (e) {
      Err.handle(e);
    }
  },
  [PRINT_COMMISSIONS]: async (context, {
    clientUsername,
    applicationId,
    mortgage
  }) => {
    try {
      const {
        signedFileOptions
      } = await printCommissions(clientUsername, applicationId, mortgage);
      openFileDialog(signedFileOptions == null ? void 0 : signedFileOptions.s3PresignedUrl, signedFileOptions == null ? void 0 : signedFileOptions.documentId, {
        newWindow: true
      });
      return {
        succeeded: true
      };
    } catch (e) {
      Err.handle(e, {}, e == null ? void 0 : e.message);
      return {
        succeeded: false
      };
    }
  },
  [UPDATE_SUBMISSIONS_HISTORY_AFTER_APPLICATION_COMPLETE]: async (context, {
    completeStatus,
    applicationCompleted
  }) => {
    const {
      submissionHistory
    } = context.state;
    if (!submissionHistory.allIds.length) return;
    submissionHistory.allIds.forEach(submissionId => {
      const submission = submissionHistory.byId[submissionId];
      context.commit(SET_SUBMISSION_HISTORY_STATUS, {
        submissionId: submission.submissionId,
        status: getNewStatusAfterSubmission(submission.status, completeStatus, applicationCompleted)
      });
    });
  },
  [ASSIGN_APPLICATION_REFERRAL_SOURCE]: async (context, {
    referrerId,
    applicationId,
    clientUsername
  }) => {
    const currentApplication = context.getters["CURRENT_APPLICATION"];
    const oldReferralSource = currentApplication.referrerId;
    context.commit(SET_APPLICATION_REFERRAL_SOURCE, {
      referrerId
    });
    try {
      await assignReferralSource(clientUsername, applicationId, referrerId);
    } catch (e) {
      Err.handle(e);
      context.commit(SET_APPLICATION_REFERRAL_SOURCE, {
        referrerId: oldReferralSource
      });
      throw e;
    }
  },
  [LOAD_COMMISSIONS_FEES]: async (context, {
    applicationId,
    clientUsername,
    mortgageType
  }) => {
    try {
      const {
        applicationCommissionsFees,
        brokerageFee,
        findersFee,
        totalFees
      } = await getCommissionsFees(applicationId, clientUsername, mortgageType);
      const defaultFees = [_objectSpread(_objectSpread({}, brokerageFee), {}, {
        commissionsFeeId: "brokerageFee",
        type: i18n.t("direct-to-lender.commissions.fees.brokerageFee"),
        description: "",
        mortgageType,
        default: true
      }), _objectSpread(_objectSpread({}, findersFee), {}, {
        commissionsFeeId: "findersFee",
        type: i18n.t("direct-to-lender.commissions.fees.findersFee"),
        description: "",
        mortgageType,
        default: true
      })];
      const {
        entities,
        result
      } = normalize([...defaultFees, ...applicationCommissionsFees], [commissionsFeesSchema]);
      const normalizedFees = {
        byId: entities.commissionsFees || {},
        allIds: result
      };
      context.commit(SET_COMMISSIONS_FEES, {
        commissionsFees: normalizedFees,
        mortgageType
      });
      context.commit(SET_TOTAL_COMMISSIONS_FEES, {
        totalFees
      });
    } catch (e) {
      Err.handle(e);
    }
  },
  [ADD_NEW_COMMISSION_FEE]: async (context, {
    applicationId,
    clientUsername,
    mortgageType
  }) => {
    try {
      context.commit(SET_LOADING_TOTAL_COMMISSIONS_FEES, true);
      const {
        commissionsFeeId,
        totalFees
      } = await addCommissionFee(applicationId, clientUsername, mortgageType);
      context.commit(ADD_COMMISSION_FEE, {
        mortgageType,
        commissionsFeeId
      });
      context.commit(SET_TOTAL_COMMISSIONS_FEES, {
        totalFees
      });
      context.commit(SET_LOADING_TOTAL_COMMISSIONS_FEES, false);
    } catch (e) {
      Err.handle(e);
    }
  },
  [DELETE_COMMISSION_FEE]: async (context, {
    applicationId,
    clientUsername,
    commissionsFeeId,
    mortgageType
  }) => {
    try {
      context.commit(SET_LOADING_TOTAL_COMMISSIONS_FEES, true);
      const {
        totalFees
      } = await deleteCommissionFee(applicationId, clientUsername, commissionsFeeId);
      context.commit(REMOVE_COMMISSION_FEE, {
        commissionsFeeId,
        mortgageType
      });
      context.commit(SET_TOTAL_COMMISSIONS_FEES, {
        totalFees
      });
      context.commit(SET_LOADING_TOTAL_COMMISSIONS_FEES, false);
    } catch (e) {
      Err.handle(e);
    }
  },
  [CHANGE_COMMISSION_FEE]: async (context, {
    applicationId,
    clientUsername,
    commissionFee,
    mortgageType
  }) => {
    try {
      if (commissionFee.default) {
        context.commit(SET_LOADING_TOTAL_COMMISSIONS_FEES, true);
        const {
          totalFees
        } = await changeDefaultCommissionFee(applicationId, clientUsername, commissionFee);
        context.commit(SET_TOTAL_COMMISSIONS_FEES, {
          totalFees
        });
        context.commit(SET_LOADING_TOTAL_COMMISSIONS_FEES, false);
      } else {
        context.commit(SET_LOADING_TOTAL_COMMISSIONS_FEES, true);
        const {
          totalFees
        } = await changeCommissionFee(applicationId, clientUsername, commissionFee);
        context.commit(SET_TOTAL_COMMISSIONS_FEES, {
          totalFees
        });
        context.commit(SET_LOADING_TOTAL_COMMISSIONS_FEES, false);
      }
      context.commit(SET_COMMISSION_FEE, {
        fee: commissionFee,
        mortgageType
      });
    } catch (e) {
      Err.handle(e);
    }
  },
  [CREATE_COMMISSION_DEDUCTION]: async (context, {
    applicationId,
    clientUsername,
    mortgageType
  }) => {
    try {
      const {
        commissionsDeductionId
      } = await createCommissionDeduction(applicationId, clientUsername, mortgageType);
      context.commit(ADD_COMMISSION_DEDUCTION, {
        applicationId,
        commissionsDeductionId
      });
    } catch (e) {
      Err.handle(e);
    }
  },
  [SAVE_COMMISSION_DEDUCTION]: async (context, {
    clientUsername,
    applicationId,
    mortgageType,
    commissionsDeductionId,
    deduction
  }) => {
    try {
      const updatedDeduction = {};
      updatedDeduction.amount = deduction.amount;
      if (deduction.type) updatedDeduction.type = deduction.type;
      if (deduction.fundsReceived) updatedDeduction.fundsReceived = moment(deduction.fundsReceived).format("YYYY-MM-DD");
      if (deduction.description) updatedDeduction.description = deduction.description;
      const {
        totalDeductions
      } = await updateCommissionDeduction(clientUsername, applicationId, commissionsDeductionId, _objectSpread(_objectSpread({}, updatedDeduction), {}, {
        mortgageType
      }));
      context.commit(SET_COMMISSION_CALCULATED_DETAILS, {
        applicationId,
        totalDeductions
      });
      context.commit(UPDATE_COMMISSION_DEDUCTION, {
        applicationId,
        commissionsDeductionId,
        deduction
      });
    } catch (e) {
      Err.handle(e);
    }
  },
  [REMOVE_COMMISSION_DEDUCTION]: async (context, {
    clientUsername,
    applicationId,
    commissionsDeductionId
  }) => {
    try {
      const {
        totalDeductions
      } = await deleteCommissionDeduction(clientUsername, applicationId, commissionsDeductionId);
      context.commit(SET_COMMISSION_CALCULATED_DETAILS, {
        applicationId,
        totalDeductions
      });
      context.commit(DELETE_COMMISSION_DEDUCTION, {
        applicationId,
        commissionsDeductionId
      });
    } catch (e) {
      Err.handle(e);
    }
  },
  [GET_COMMISSION_DEDUCTION]: async (context, {
    clientUsername,
    applicationId,
    mortgageType
  }) => {
    try {
      const {
        applicationCommissionsDeductions,
        totalDeductions
      } = await getCommissionDeduction(clientUsername, applicationId, mortgageType);
      const {
        entities,
        result
      } = normalize(applicationCommissionsDeductions, [commissionDeductionsSchema]);
      await context.commit(SET_COMMISSION_DEDUCTION, {
        applicationId,
        commissionDeductions: {
          byId: entities.commissionDeductions || {},
          allIds: result
        }
      });
      context.commit(SET_COMMISSION_CALCULATED_DETAILS, {
        applicationId,
        totalDeductions
      });
    } catch (e) {
      Err.handle(e);
    }
  },
  [LOAD_COMMISSIONS_DETAILS]: async (context, {
    applicationId,
    clientUsername,
    mortgageType
  }) => {
    try {
      const applicationCommissionDetails = await getCommissionsDetails(applicationId, clientUsername, mortgageType);
      const {
        commissionsDetailsAndParticipants
      } = await getCommissionsDetailsParticipants(applicationId, clientUsername, mortgageType);
      const {
        entities,
        result
      } = normalize(commissionsDetailsAndParticipants, [commissionParticipantsSchema]);
      context.commit(SET_COMMISSIONS_DETAILS, {
        applicationId,
        commissionsDetails: _objectSpread(_objectSpread({}, applicationCommissionDetails), {}, {
          participants: {
            allIds: result,
            byId: entities.commissionParticipants || {}
          }
        })
      });
    } catch (e) {
      Err.handle(e);
    }
  },
  [ADD_COMMISSIONS_DETAILS_PARTICIPANT]: async (context, {
    applicationId,
    clientUsername,
    mortgageType,
    participant
  }) => {
    try {
      const agentDetailsEB = {
        firstName: participant.firstName,
        lastName: participant.lastName,
        expertProfileId: participant.expertProfileId
      };
      const {
        commissionsParticipantId
      } = await addCommissionsDetailsParticipant(applicationId, clientUsername, mortgageType, participant.username, agentDetailsEB);
      const formattedParticipant = _objectSpread(_objectSpread({}, participant), {}, {
        agentSplit: 0,
        fees: 0,
        netFees: 0,
        primaryContact: false,
        givenName: participant.firstName,
        familyName: participant.lastName,
        commissionsParticipantId
      });
      context.commit(SET_COMMISSIONS_DETAILS_PARTICIPANT, {
        applicationId,
        participant: formattedParticipant
      });
      showToast("success", "participantAdded");
    } catch (e) {
      Err.handle(e);
    }
  },
  [REMOVE_COMMISSIONS_DETAILS_PARTICIPANT]: async (context, {
    applicationId,
    clientUsername,
    commissionsParticipantId
  }) => {
    const deletedParticipant = context.state.commissions.commissionDetails.byApplication[applicationId].participants.byId[commissionsParticipantId];
    try {
      context.commit(DELETE_COMMISSIONS_DETAILS_PARTICIPANT, {
        applicationId,
        commissionsParticipantId
      });
      const participants = context.getters[GET_COMMISSION_DETAILS_PARTICIPANTS](applicationId);
      if (participants.length === 1 && !context.getters[IS_AGENTS_SPLIT_SUMMARY_COMPLETED](applicationId)) {
        const agentSplits = [{
          id: participants[0].commissionsParticipantId,
          agentSplit: 100
        }];
        context.commit(SET_COMMISSIONS_DETAILS_PARTICIPANT, {
          applicationId,
          participant: _objectSpread(_objectSpread({}, participants[0]), {}, {
            agentSplit: 100
          })
        });
        await updateParticipantsSplits(applicationId, clientUsername, agentSplits);
      }
      await deleteCommissionsDetailsParticipant(applicationId, clientUsername, commissionsParticipantId);
    } catch (e) {
      Err.handle(e);
      context.commit(SET_COMMISSIONS_DETAILS_PARTICIPANT, {
        applicationId,
        participant: deletedParticipant
      });
    }
  },
  [UPDATE_COMMISSIONS_DETAILS_PARTICIPANT]: async (context, {
    applicationId,
    clientUsername,
    participant,
    save = true
  }) => {
    try {
      context.commit(SET_COMMISSIONS_DETAILS_PARTICIPANT, {
        applicationId,
        participant
      });
      if (save && context.getters[IS_AGENTS_SPLIT_SUMMARY_COMPLETED](applicationId)) {
        var _context2;
        const agentSplits = _mapInstanceProperty(_context2 = context.getters[GET_COMMISSION_DETAILS_PARTICIPANTS](applicationId)).call(_context2, participant => ({
          id: participant.commissionsParticipantId,
          agentSplit: Number(participant.agentSplit)
        }));
        await updateParticipantsSplits(applicationId, clientUsername, agentSplits);
      }
    } catch (e) {
      Err.handle(e);
    }
  },
  [UPDATE_COMMISSIONS_DETAILS_PRIMARY_CONTACT]: async (context, {
    applicationId,
    clientUsername,
    participant
  }) => {
    const {
      commissionsParticipantId: oldPrimaryContact
    } = context.getters[GET_COMMISSION_DETAILS_PRIMARY_CONTACT](applicationId);
    try {
      context.commit(SET_COMMISSIONS_DETAILS_PRIMARY_CONTACT, {
        applicationId,
        oldPrimaryContact,
        newPrimaryContact: participant.commissionsParticipantId
      });
      await updatePrimaryContact(applicationId, clientUsername, participant.commissionsParticipantId);
    } catch (e) {
      context.commit(SET_COMMISSIONS_DETAILS_PRIMARY_CONTACT, {
        applicationId,
        oldPrimaryContact: participant.commissionsParticipantId,
        newPrimaryContact: oldPrimaryContact
      });
      Err.handle(e);
    }
  },
  [UPDATE_COMMISSIONS_DETAILS]: async (context, {
    applicationId,
    commissionsDetails,
    clientUsername,
    mortgageType,
    save = true
  }) => {
    const oldDetails = context.state.commissions.commissionDetails.byApplication[applicationId];
    try {
      const details = _objectSpread(_objectSpread({}, oldDetails), commissionsDetails);
      context.commit(SET_COMMISSIONS_DETAILS, {
        applicationId,
        commissionsDetails: _objectSpread(_objectSpread({}, oldDetails), commissionsDetails)
      });
      if (save) {
        await updateCommissionsDetails(applicationId, clientUsername, mortgageType, omit(details, "participants"));
      }
    } catch (e) {
      context.commit(SET_COMMISSIONS_DETAILS, {
        applicationId,
        commissionsDetails: {
          oldDetails
        }
      });
      Err.handle(e);
    }
  },
  [LOAD_CO_BROKERING_HISTORY]: async (context, {
    clientUsername,
    applicationId
  }) => {
    try {
      const coBrokeringHistory = await getCoBrokeringHistory(clientUsername, applicationId);
      context.commit(SET_CO_BROKERING_HISTORY, {
        coBrokeringHistory
      });
    } catch (e) {
      Err.handle(e);
    }
  },
  [LOAD_CO_BROKER_BROKERAGES]: async (context, {
    searchString = "",
    offset,
    limit
  }) => {
    try {
      const {
        brokerageCount,
        brokerages
      } = await getCoBrokerBrokerages(searchString, offset, limit);
      context.commit(SET_CO_BROKER_BROKERAGES, {
        brokerages
      });
      context.commit(SET_CO_BROKER_BROKERAGES_COUNT, {
        brokerageCount
      });
    } catch (e) {
      Err.handle(e);
    }
  },
  [LOAD_CO_BROKER_AGENTS]: async (context, {
    agentFirstName,
    agentLastName,
    brokerageId,
    offset,
    limit
  }) => {
    try {
      context.commit(SET_LOADING_CO_BROKER_AGENTS, {
        loading: true
      });
      const {
        agents,
        totalAgents
      } = await getCoBrokerAgents(agentFirstName, agentLastName, brokerageId, offset, limit);
      context.commit(SET_LOADING_CO_BROKER_AGENTS, {
        loading: false
      });
      context.commit(SET_CO_BROKER_AGENTS_COUNT, {
        totalAgents
      });
      return {
        agents,
        totalAgents
      };
    } catch (e) {
      Err.handle(e);
    }
  },
  [LOAD_CO_BROKER_FAVORITES]: async (context, {
    offset,
    limit
  }) => {
    try {
      context.commit(SET_LOADING_CO_BROKER_AGENTS, {
        loading: true
      });
      const {
        agents,
        totalAgents
      } = await getCoBrokerFavorites(offset, limit);
      context.commit(SET_LOADING_CO_BROKER_AGENTS, {
        loading: false
      });
      context.commit(SET_CO_BROKER_AGENTS_COUNT, {
        totalAgents
      });
      return {
        agents,
        totalAgents
      };
    } catch (e) {
      Err.handle(e);
    }
  },
  [ADD_CO_BROKER_TO_FAVORITES_LIST]: async (context, {
    usernameToFavorite
  }) => {
    try {
      context.commit(SET_LOADING_CO_BROKER_AGENTS, {
        loading: true
      });
      await addCoBrokerToFavoritesList(usernameToFavorite);
    } catch (e) {
      Err.handle(e, {}, "failedToAddToFavoritesList");
    }
  },
  [REMOVE_CO_BROKER_FROM_FAVORITES_LIST]: async (context, {
    usernameToUnfavorite
  }) => {
    try {
      context.commit(SET_LOADING_CO_BROKER_AGENTS, {
        loading: true
      });
      await removeCoBrokerFromFavoritesList(usernameToUnfavorite);
    } catch (e) {
      Err.handle(e, {}, "failedToRemoveFromFavoritesList");
    }
  },
  [UPDATE_CO_BROKERED_MORTGAGE]: (context, {
    index,
    type,
    refiAdditionalInfo
  }) => {
    var _mortgageDetails$mort, _application$property, _application$property2, _application$property3, _context$getters$CURR, _context$getters$CURR2, _context3;
    const mortgageDetails = context.getters[CURRENT_APPLICATION]["mortgage-details"];
    const mortgages = cloneDeep((_mortgageDetails$mort = mortgageDetails.mortgages) != null ? _mortgageDetails$mort : []);

    // Add a new record under Subject Property
    const generator = new ApplicationGenerator(context.state.schema);
    const {
      application
    } = generator.buildApp("refinance-approval");
    const emptyExistingMortgage = (_application$property = application == null ? void 0 : (_application$property2 = application.property) == null ? void 0 : (_application$property3 = _application$property2["existing-mortgages"]) == null ? void 0 : _application$property3[0]) != null ? _application$property : {};
    const amount = mortgages[index].amount;
    const existingMortgages = (_context$getters$CURR = context.getters[CURRENT_APPLICATION]) == null ? void 0 : (_context$getters$CURR2 = _context$getters$CURR.property) == null ? void 0 : _context$getters$CURR2["existing-mortgages"];
    const hasExistingMortgages = !isEmpty(existingMortgages);
    if (hasExistingMortgages) {
      const mortgageIndex = _findIndexInstanceProperty(existingMortgages).call(existingMortgages, ({
        "mortgage-type": mortgageType
      }) => mortgageType === type);
      if (mortgageIndex > -1) {
        context.dispatch(REMOVE_APPLICATION_GROUP, {
          where: "property[existing-mortgages]",
          index: mortgageIndex
        });
      }
    }
    context.dispatch(ADD_APPLICATION_GROUP, {
      what: _objectSpread(_objectSpread({}, emptyExistingMortgage), {}, {
        "mortgage-type": type,
        "orig-amount": amount,
        "refi-additional-info": refiAdditionalInfo
      }),
      where: "property[existing-mortgages]",
      startEmpty: !hasExistingMortgages,
      markAsVisible: !hasExistingMortgages
    });

    // Update mortgage to existing
    mortgages[index].requested = "existing";

    // Add this mortgage to cobrokeredMortgages
    const cobrokeredMortgages = _mapInstanceProperty(_context3 = context.getters[CO_BROKERING_HISTORY]).call(_context3, ({
      mortgageType
    }) => mortgageType);

    // Update application in the state
    context.commit(UPDATE_APPLICATION_DETAILS, {
      applicationId: context.getters[CURRENT_APPLICATION_ID],
      "mortgage-details": _objectSpread(_objectSpread({}, mortgageDetails), {}, {
        mortgages
      }),
      cobrokeredMortgages
    });
  }
};